// Archivo que maneja el servicio de chat en el frontend

import api from './api'

export const listConversations = async () => {
  const response = await api.get('/chat/conversations')
  return response.data
}

export const createConversation = async (payload) => {
  const response = await api.post('/chat/conversations', payload)
  return response.data
}

export const listMessages = async (conversationId, params = {}) => {
  const response = await api.get(
    `/chat/conversations/${conversationId}/messages`,
    { params }
  )
  return response.data
}

export const sendMessage = async (conversationId, payload) => {
  const response = await api.post(
    `/chat/conversations/${conversationId}/messages`,
    payload
  )
  return response.data
}

// ✅ FIX ESLint: export nombrado, no anónimo
const chatService = {
  listConversations,
  createConversation,
  listMessages,
  sendMessage,
}

export default chatService
